import React from "react";
import { DeviceStatusManager, useDeviceStatusManager } from "./DeviceStatusManager";
import InfoLog from "./InfoLog";
import StatusLog from "./StatusLog";

function Show({device}){
    const {type} = useDeviceStatusManager();
    return type === "info" ? <StatusLog device={device} /> : <InfoLog device={device} />  
}

export default function({device}){
    return <DeviceStatusManager>
        <Show device={device} />
    </DeviceStatusManager>
}